export default function () {
  const widgetName = "multiScheduleFeature";
  const widgetOpts = multiScheduleFeatureOpts;

  const boxWrapper = document.getElementById("multiScheduleFeature");

  const box = document.createElement("div");
  box.innerHTML =
    '<div id="events-header"><div id="sub-left"></div><div id="sub-right">EVENT CALENDAR</div><div class="clear-both"></div></div>';
  box.classList.add("box");

  boxWrapper.appendChild(box);

  $(`#${widgetName}`).append('<div class="multiFeatureContent"></div>');

  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID,
    detectIpad: IPADDETECTED,
    // options
    allEventsLink: true,
    allEventsLinkText: "View Full Callendar",
    hasImages: false,
    imageBackground: false,
    lazyLoadImages: true,
    buyNowButton: { visible: false, text: "BUY NOW" },
    moreButton: { visible: false, text: "MORE" },
    maxItemsVisible: 4,
    isResponsive: false,
    hasDescription: false,
    textContainer: true,
    link: "imageAndText", //options are 'all', 'text', 'image', 'imageAndText', or ''
    attributeOrder: {
      1: "title",
      2: "date",
      3: "image",
      4: "description",
      5: "buttons",
    },
    multiFeatureLoaded: function (data) {
      console.log(data);
      // use function below if "more" text needs to appear at end of description text

      $("#multiScheduleFeature .featureItem").each(function () {
        const itemTitle = $(this).find(".featureItemTitle");
        const characterLimit = 30;
        const itemTitleText = itemTitle.text();
        if (itemTitleText.length > characterLimit) {
          const trimmedText =
            itemTitleText.substring(0, characterLimit) + "...";
          itemTitle.text(trimmedText);
        }

        //  var itemDescripton = $(this).find('.featureItemDescription');

        // // uncomment below if you need to slice the date string up into something shorter like "Oct 31"
        // var eventDate = $(this).find($('span.featureItemDate'));
        // var datesMonth = eventDate.text().slice(0,3);
        // var datesDay = eventDate.text().slice(4,7).replace(',','');
        // eventDate.text(datesMonth);
        // eventDate.append("<span>"+datesDay+"</span>");
        //  eventDate.append("<div>hello</div>");
        // // uncomment below if you need to limit the characters in the description text
        // var characterLimit = 120;
        // var itemDescriptonText = itemDescripton.text();
        // if ( itemDescriptonText.length > characterLimit ) {
        //   var trimmedText = itemDescriptonText.substring(0,characterLimit) + '...';
        //   itemDescripton.text(trimmedText);
        // }

        // uncomment below if 'more' link is needed after event description
        //itemDescripton.append("<span class='more-text'>More</span>");
      });
    },
  });
}
